<template>
  <th
    :class="[
      'px-6 py-4 text-left text-xs font-medium uppercase tracking-wider text-transparent sm:text-zinc-400 whitespace-nowrap',
      props.class,
    ]"
  >
    <div class="flex items-center gap-2">
      <slot />
    </div>
  </th>
</template>

<script setup lang="ts">
const props = defineProps<{ class?: string }>()
</script>
